import startCase from 'lodash/startCase';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex } from 'roo-ui/components';
import { useDataLayer } from 'hooks/useDataLayer';
import { setActiveCategory } from 'store/promoArea/promoAreaActions';
import { getActiveCategory, getCategories, getIsLoading } from 'store/promoArea/promoAreaSelectors';
import { NavLink, SkeletonNav } from 'pages/ListSearch/PromoArea/primitives';

const PromoNav = React.memo(() => {
  const dispatch = useDispatch();
  const { emitInteractionEvent } = useDataLayer();

  const isLoading = useSelector(getIsLoading);
  const categories = useSelector(getCategories) || [];
  const activeCategory = useSelector(getActiveCategory);
  const isVisible = categories.length > 1;

  useEffect(() => {
    const activeCategory = categories[0];

    if (activeCategory) {
      dispatch(setActiveCategory(activeCategory));

      emitInteractionEvent({
        type: 'Promo Area',
        value: startCase(`${activeCategory.name} displayed`),
      });
    }
  }, [categories, dispatch, emitInteractionEvent]);

  const onChangeActiveCategory = useCallback(
    (activeCategory) => {
      dispatch(setActiveCategory(activeCategory));

      emitInteractionEvent({
        type: 'Promo Area',
        value: startCase(`${activeCategory.name} selected`),
      });
    },
    [dispatch, emitInteractionEvent],
  );

  return (
    <Flex minHeight={65} py={4}>
      {isLoading && <SkeletonNav />}
      {!isLoading &&
        isVisible &&
        categories.map((category) => (
          <NavLink key={category.code} isActive={category.code === activeCategory.code} onClick={() => onChangeActiveCategory(category)}>
            {category.name}
          </NavLink>
        ))}
    </Flex>
  );
});

PromoNav.displayName = 'PromoNav';

export default PromoNav;
